import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-sm' : 'bg-transparent'}`}>
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <div className="flex items-center">
          <img
            src="https://static.readdy.ai/image/9bc2178766357ca1f8e7030b470115cf/c42f4a326432be1cf9baf0d20e3986f8.png"
            alt="STORAD - Store Affiliate Network"
            className="h-10 w-auto object-contain"
          />
        </div>
        <nav className="hidden md:flex items-center gap-7 text-sm font-medium">
          {[
            { label: 'サービス概要', id: 'service' },
            { label: 'QR活用方法', id: 'qr-usage' },
            { label: '仕組み', id: 'affiliate' },
            { label: '導入事例', id: 'cases' },
            { label: '料金プラン', id: 'pricing' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className={`cursor-pointer whitespace-nowrap transition-colors ${scrolled ? 'text-gray-700 hover:text-red-500' : 'text-white hover:text-red-300'}`}
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('contact')}
            className="cursor-pointer whitespace-nowrap bg-red-500 text-white px-5 py-2 rounded-md text-sm font-semibold hover:bg-red-600 transition-colors"
          >
            無料お問い合わせ
          </button>
        </nav>
        <button
          className={`md:hidden cursor-pointer ${scrolled ? 'text-gray-800' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
        </button>
      </div>
      {menuOpen && (
        <div className="md:hidden bg-white shadow-md px-6 py-4 flex flex-col gap-4">
          {[
            { label: 'サービス概要', id: 'service' },
            { label: 'QR活用方法', id: 'qr-usage' },
            { label: '仕組み', id: 'affiliate' },
            { label: '導入事例', id: 'cases' },
            { label: '料金プラン', id: 'pricing' },
            { label: 'お問い合わせ', id: 'contact' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="cursor-pointer whitespace-nowrap text-left text-gray-700 text-sm font-medium hover:text-red-500"
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
